// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__WQPIn","rainbow":"style_rainbow__PLNAy","image":"style_image__3yxiq"};